/**
 * editor.setEditorHostSettings -> https://confluence.gelato.tech/display/AD/editor.setEditorHostSettings
 */
export enum EditorInboundEventType {
  setEditorHostSettings = 'editor.setEditorHostSettings',
  setSidebarTabs = 'editor.setSidebarTabs',
  setSidebarActiveTabName = 'editor.setSidebarActiveTabName',
  setSidebarActiveTab = 'editor.setSidebarActiveTab',
  setTrackDesignChanges = 'editor.setTrackDesignChanges',
  setDefaultZoom = 'editor.setDefaultZoom',
  setSpreadsDefaultZoom = 'editor.setSpreadsDefaultZoom',
  setLocale = 'editor.setLocale',
  setDefaultTextStyle = 'editor.setDefaultTextStyle',
  setDefaultPersonalizationLock = 'editor.setDefaultPersonalizationLock',
  setupChameleon = 'editor.setupChameleon',
  setupAmplitude = 'editor.setupAmplitude',
  setDisabledSpreads = 'editor.setDisabledSpreads',
  setImagePatternScaleBases = 'editor.setImagePatternScaleBases',

  applyDesignDataTo = 'design.applyDesignDataTo',
  setDesignData = 'design.setDesignData',
  requestDesignData = 'design.requestDesignData',
  spreadBackgrounds = 'design.spreadBackgrounds',
  spreadForegrounds = 'design.spreadForegrounds',
  setAutoApplyLayoutSchemaNames = 'design.setAutoApplyLayoutSchemaNames',
  setQuantizedAsset = 'design.setQuantizedAsset',
  setQuantizedAssetError = 'design.setQuantizedAssetError',
  setDigitizedAsset = 'design.setDigitizedAsset',
  setDigitizedAssetError = 'design.setDigitizedAssetError',
  setHostWarnings = 'design.setHostWarnings',

  loadUploadedImages = 'gallery.loadUploadedImages',
  setUploadedImages = 'gallery.setUploadedImages',
  removeImages = 'gallery.removeImages',

  previewGeneratedSuccess = 'uploader.previewGeneratedSuccess',
  previewGeneratedRemotelySuccess = 'uploader.previewGeneratedRemotelySuccess',
  previewGeneratedError = 'uploader.previewGeneratedError',
  previewGeneratedRemotelyError = 'uploader.previewGeneratedRemotelyError',
  uploadSuccess = 'uploader.uploadSuccess',
  uploadError = 'uploader.uploadError',
  uploadProgress = 'uploader.uploadProgress',
  uploadStart = 'uploader.uploadStart',
  setUploaderConfig = 'uploader.setConfig',

  setRenders = 'preview.setRenders',
  flatPreviewReady = 'preview.flatPreviewReady',
  flatPreviewFailed = 'preview.flatPreviewFailed',
  rendersError = 'preview.rendersError',
  setFlatPreviewAvailable = 'preview.setFlatPreviewAvailable',
  setThe3dPreviewAvailable = 'preview.setThe3dPreviewAvailable',

  setProductData = 'variants.setProductData',
  setAsVariantFlow = 'variants.setAsVariantFlow',
  designTemplates = 'variants.designTemplates',

  applyTemplate = 'templates.applyTemplate',
  setTemplates = 'templates.setTemplates',
  setLayoutsAllowedTags = 'layouts.setAllowedTags',

  setAddons = 'addons.setAddons',
  addonUploaded = 'addons.addonUploaded',
  assetUploaded = 'plugins.assetUploaded',
  assetUploadedFailed = 'plugins.assetUploadFailed',
  addonUploadFailed = 'addons.addonUploadFailed',

  setAssetWithReplacedColors = 'asset.setAssetWithReplacedColors',

  trackEvent = 'event.trackEvent',

  setPlugins = 'plugins.setPlugins',
  setData = 'plugins.setData',

  applyModifiedImage = 'plugins.applyModifiedImage',
  resetModifiedImage = 'plugins.resetModifiedImage',

  setExtractedFields = 'plugins.setExtractedFields',

  mockupSetData = 'mockup.setData',
  mockupSetScenePlaceholderData = 'mockup.setScenePlaceholderData',
  mockupVariant = 'mockup.variant',
  mockupSetSceneStructure = 'mockup.setSceneStructure',
  mockupSetMockupStructure = 'mockup.setMockupStructure',
  mockupSetPreview = 'mockup.setPreview',
  mockupPreviewGenerationFailed = 'mockup.previewGenerationFailed',
  mockupSetProductPreview = 'mockup.setProductPreview',
  mockupProductPreviewGenerationFailed = 'mockup.productPreviewGenerationFailed',
  mockupSetStores = 'mockup.setStores',
  mockupSetStoreProducts = 'mockup.setStoreProducts',
  mockupSetStoreProductVariants = 'mockup.setStoreProductVariants',
  mockupDownloadStarted = 'mockup.downloadStarted',
  mockupDownloadReady = 'mockup.downloadReady',
  mockupDownloadError = 'mockup.downloadError',
  mockupSetProductScenes = 'mockup.setProductScenes',
  mockupSetProductData = 'mockup.mockupSetProductData',

  variantsSetLimit = 'variants.setLimit',
}
